const doc = [({"da":({"js":({"admin":({"activities":({"create_card":({"expandable_content":({"required_metadata_on_sign_up":"Tilmelding - Stamdata"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;